module.exports = __webpack_public_path__ + "img/sign.ca5bc931.png";